import { render, staticRenderFns } from "./monitoringDetails.vue?vue&type=template&id=1a8474c3&scoped=true"
import script from "./monitoringDetails.vue?vue&type=script&lang=js"
export * from "./monitoringDetails.vue?vue&type=script&lang=js"
import style0 from "./monitoringDetails.vue?vue&type=style&index=0&id=1a8474c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8474c3",
  null
  
)

export default component.exports